import { gql } from "@apollo/client";

export const CREATE_WAREHOUSE = gql`
  mutation CreateWarehouse($input: WarehouseInput) {
    createWarehouse(input: $input) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;
export const GET_WAREHOUSE = gql`
  query GetWarehouse($isUse: Boolean, $keyword: String) {
    getWarehouse(isUse: $isUse, keyword: $keyword) {
      _id
      warehouseName
      location
      imageSrc
      isUse
      remark
    }
  }
`;

export const UPDATE_ISUSE_STATUS = gql`
  mutation UpdateWarehouseIsUse($id: ID!, $isUse: Boolean) {
    updateWarehouseIsUse(_id: $id, isUse: $isUse) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const UPDATE_WAREHOUSE = gql`
  mutation UpdateWarehouse($id: ID!, $input: WarehouseInput) {
    updateWarehouse(_id: $id, input: $input) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const DELETE_WAREHOUSE = gql`
  mutation DeleteWarehouse($id: ID!) {
    deleteWarehouse(_id: $id) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const SELECT_WAREHOUSE = gql`
  query SelectWarehouse {
    selectWarehouse {
      _id
      warehouseName
      location
      imageSrc
    }
  }
`;
